import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { SiTypescript,SiHtml5 } from "react-icons/si";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiCss3,
  DiGithubBadge
} from "react-icons/di";
import {
  SiLinux,
  SiVisualstudiocode,
  SiPostman,
  SiHeroku,
  SiVercel,
  SiNetlify,
  SiMaterialui,
  SiChakraui,
  SiBootstrap,SiAmazonaws
} from "react-icons/si";
import {TbBrandNextjs} from  "react-icons/tb"
import Particle from "../Atom";


function Skill() {
  return (
    <Container fluid className="skillcontainer" >
      
    <Container className="skillsdevelop">
    <h1 className="project-heading">
          Skills <strong className="purple">Abilities </strong>
        </h1>
    <Row style={{ justifyContent: "center", paddingBottom: "50px" ,borderRadius:'50%' }}>
      
      <Col xs={1} md={2} className="icons">
        <DiJavascript1 />
      </Col>
      <Col xs={4} md={2} className="icons">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="icons">
        <DiReact />
      </Col>
      <Col xs={4} md={2} className="icons">
        <DiMongodb />
      </Col>
      <Col xs={4} md={2} className="icons">
        <SiTypescript />
      </Col>
      <Col xs={4} md={2} className="icons">
        <SiHtml5 />
      </Col>
      <Col xs={4} md={2} className="icons">
        <DiCss3 />
      </Col>
      <Col xs={4} md={2} className="icons">
        <TbBrandNextjs />
      </Col>
      

<Col xs={4} md={2} className="icons">
  <SiVisualstudiocode />
</Col>
<Col xs={4} md={2} className="icons">
  <SiPostman />
</Col>
<Col xs={4} md={2} className="icons">
  <SiVercel />
</Col>
<Col xs={4} md={2} className="icons">
  <SiHeroku />
</Col>
<Col xs={4} md={2} className="icons">
  <DiGithubBadge />
</Col>
<Col xs={4} md={2} className="icons">
  <SiNetlify />
</Col>
<Col xs={4} md={2} className="icons">
  <SiMaterialui />
</Col>
<Col xs={4} md={2} className="icons">
  <SiChakraui />
</Col>
<Col xs={4} md={2} className="icons">
  <SiBootstrap />
</Col>
<Col xs={4} md={2} className="icons">
  <SiAmazonaws />
</Col>
</Row>
      
</Container>
</Container>
  );
}

export default Skill;
